<template>
  <el-dialog width="520px" title="查看详情"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productDetailVisible"  append-to-body>
    <div class="details" v-loading="loading">
      <el-form  ref="currencyForm"  size="small"   label-position="top"  >
        <el-row  type="flex" style="flex-wrap: wrap">

          <el-col :span="12" >
            <el-form-item prop="" label="产品名称">
              <div class="filed_value" v-text="productDetail.product ? productDetail.product.product_name : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12" >
            <el-form-item prop="" label="激活码">
              <div class="filed_value" v-text="productDetail.license_code ? productDetail.license_code : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="购买时间">
              <div class="filed_value" v-text="(productDetail.order && productDetail.order.pay_date) ? convertToCurrentTimezone(productDetail.order.pay_date,'/','datetime') : ''">  </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="订单号">
              <div class="filed_value" v-text="productDetail.order ? productDetail.order.order_num : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="当前状态">
              <div class="filed_value" v-text="productDetail.machine_id ? '已激活' : '未激活'"></div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="" label="有效期截止日">
              <div class="filed_value" v-if="productDetail.order" v-text="convertToCurrentTimezone(productDetail.order.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(productDetail.order.end_date,'/','datetime') "></div>
            </el-form-item>
          </el-col>

          <div class="line"></div>

          <el-col :span="24">
            <el-form-item prop="" label="模块信息">
              <div class="config_toolbar">
                <el-tag size="small" :type="productDetail.is_custom_config ? 'warning' : 'success'">
                  {{ productDetail.is_custom_config ? '单独配置' : '使用订单配置' }}
                </el-tag>
                <div>
                  <el-button type="text" @click="handleEditConfig">编辑配置</el-button>
                  <el-button
                    v-if="productDetail.is_custom_config"
                    type="text"
                    @click="handleRestoreConfig">恢复订单配置</el-button>
                </div>
              </div>
              <div class="filed_value">
                <p v-for="item in productDetail.license_modules">
                  <span v-text="item.module ? item.module.module_name : ''"></span> :
                  <span v-text="item.module_value ? item.module_value : (item.module_code == '1' ? '0通道' : '默认值（0）')"></span>
                </p>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="" label="备注">
              <div class="filed_value" v-text="productDetail.order ? productDetail.order.admin_note : ''"></div>
            </el-form-item>
          </el-col>



        </el-row>

      </el-form>

    </div>

    <modulesChange
      v-if="modulesVisible"
      :modulesVisible.sync="modulesVisible"
      :modulesInfo="productDetail.license_modules"
      @success="handleModulesSuccess" />

  </el-dialog>
</template>
<script>

import {mapState} from "vuex";
import {
  adminLicenseConfigEdit,
  adminLicenseConfigRestore,
  adminUserProductDetail
} from '@/api/api'
import {convertToCurrentTimezone} from '@/utils'
import modulesChange from './modules_change.vue'
export default {
  name: 'product_detail',
  components: {
    modulesChange
  },
  props: {
    productDetailVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: 0,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      productDetail:{},
      modulesVisible:false
    }
  },

  created() {
    if(this.productId){
      this.getAdminProductDetail()
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 获取
    getAdminProductDetail(){
      this.loading = true
      let postData = {
        id:this.productId,
      }
      adminUserProductDetail(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.productDetail = data
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleEditConfig(){
      this.modulesVisible = true
    },
    handleModulesSuccess(data){
      const moduleRequire = data.map(item => {
        return {
          module_id:item.module_id,
          module_code:item.module_code,
          module_value_id:item.module_value_id,
          module_value:item.module_value,
          value_code:item.value_code
        }
      })
      this.loading = true
      adminLicenseConfigEdit({
        id:this.productId,
        module_require:moduleRequire
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.getAdminProductDetail()
          this.$emit('success')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleRestoreConfig(){
      this.$confirm('恢复后，该授权将重新使用订单配置。', '恢复订单配置', {
        confirmButtonText: '确认恢复',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return adminLicenseConfigRestore({id:this.productId})
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.getAdminProductDetail()
          this.$emit('success')
        }
      }).catch(() => {})
    },

    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productDetailVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.details{
  width: 100%;
}
::v-deep .el-form-item__label{
  padding-bottom: 0;
  color: rgba(51, 51, 51, 1);
}
.filed_value{
  line-height: 20px;
  color: rgba(102, 102, 102, 1);
}
.config_toolbar{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.line{
  width: 100%;
  height: 1px;
  background: rgba(217, 217, 217, 1);
  margin-bottom: 10px;
}
</style>
